
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.69 12.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Ebene 2"}},[_c('path',{attrs:{"d":"M4.47 11.25l8-8 .22-.25-.78-.78L9.66 0 7.41 2.25l-1 1L.76 8.9l-.15.75-.25 1.25L0 12.69l2.2-.44 1.59-.32zm4.3-8.78L9 2.25l.67-.67.67.67.78.78-.22.22-.67.67-.67-.67zm-7 7L8 3.26l1.43 1.45-6.2 6.2-1.15.23-.66.13.13-.66z","data-name":"Ebene 1"}})])])
          )
        }
      }
    